import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useResettableForm } from "web_myplann/Shared/Hooks/useResettableForm";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { requiredPositiveAmount } from "web_myplann/Shared/Validation/requiredPositiveAmount";
import { z } from "zod";

const getIncomeSheetFormSchema = (t: TranslateFunction) => {
	const required = t(Resources.Form.Validations.required);

	return z.object({
		name: z.string({ required_error: required }).trim().min(1, required),
		amount: requiredPositiveAmount(
			required,
			t(Resources.Form.Validations.amountPositive),
		),
	});
};

type IncomeSheetFormSchema = ReturnType<typeof getIncomeSheetFormSchema>;

export type IncomeSheetValues = z.input<IncomeSheetFormSchema>;
export type IncomeSheetFormModel = z.output<IncomeSheetFormSchema>;

const EMPTY_VALUES: IncomeSheetValues = { name: "", amount: null };

type Params = {
	open: boolean;
	initialValues?: IncomeSheetValues;
};

export const useIncomeSheetForm = ({ open, initialValues }: Params) => {
	const { t } = useResource();

	return useResettableForm<IncomeSheetValues, IncomeSheetFormModel>({
		schema: getIncomeSheetFormSchema(t),
		open,
		emptyValues: EMPTY_VALUES,
		initialValues,
	});
};
